import { MenuView } from './Menu.view'

export const Menu = () => {
  return <MenuView />
}
